//基础信息
export default [
  {
    path: '/storeGoods',
    component: () => import("../pages/store/storeGoods.vue"),
    name: 'storeGoods',
    title: '商品管理',
    meta: {
      title: '商品管理',
    },
  },
  {
    path: '/ticketManage',
    component: () => import("../pages/store/ticketManage.vue"),
    name: 'ticketManage',
    title: '票务管理',
    meta: {
      title: '票务管理',
    },
  },
  {
    path: '/storeManage',
    component: () => import("../pages/store/storeManage.vue"),
    name: 'storeManage',
    title: '店铺管理',
    meta: {
      title: '店铺管理',
    },
  },
  {
    path: '/funTicketCalendar',
    component: () => import('../pages/store/funTicketCalendar.vue'),
    name: 'funTicketCalendar',
    title: '畅玩日历',
    meta: {
      title: '畅玩日历',
    },
  },
  {
    path: '/storeType',
    component: () => import("../pages/store/storeType.vue"),
    name: 'storeType',
    title: '畅玩分类',
    meta: {
      title: '畅玩分类',
    },
  },
  {
    path: '/userCard',
    component: () => import("../pages/store/userCard.vue"),
    name: 'userCard',
    title: '店铺消费管理',
    meta: {
      title: '店铺消费管理',
    },
  },
  {
    path: '/funOrder',
    component: () => import("../pages/store/funOrder.vue"),
    name: 'funOrder',
    title: '畅玩票务订单',
    meta: {
      title: '畅玩票务订单',
    },
  },
  {
    path: '/orderStore',
    component: () => import("../pages/store/orderStore.vue"),
    name: 'orderStore',
    title: '畅玩票务订单(旧)',
    meta: {
      title: '畅玩票务订单(旧)',
    },
  },
  {
    path: '/artShowManage',
    component: () => import("../pages/store/artShowManage.vue"),
    name: 'artShowManage',
    title: '空间美学管理',
    meta: {
      title: '空间美学管理',
    },
  },
  {
    path: '/islandTicket/ticketManage',
    component: () => import("../pages/store/islandTicket/ticketManage.vue"),
    name: 'islandTicketManage',
    title: '景区票务管理',
    meta: {
      title: '景区票务管理',
    },
  },
  {
    path: '/islandTicket/whiteList',
    component: () => import("../pages/store/islandTicket/whiteList.vue"),
    name: 'islandwhiteList',
    title: '白名单管理',
    meta: {
      title: '白名单管理',
    },
  },
  {
    path: '/islandTicket/ticketOrder',
    component: () => import("../pages/store/islandTicket/ticketOrder.vue"),
    name: 'islandTicketOrder',
    title: '景区订单管理',
    meta: {
      title: '景区订单管理',
    },
  },
  {
    path: '/islandTicket/ticketProjectManage',
    component: () => import("../pages/store/islandTicket/ticketProjectManage.vue"),
    name: 'ticketProjectManage',
    title: '门票项目管理',
    meta: {
      title: '门票项目管理',
    },
  },
  {
    path: '/brakeManage',
    component: () => import("../pages/store/brakeManage.vue"),
    name: 'brakeManage',
    title: '景区闸机管理',
    meta: {
      title: '景区闸机管理',
    },
  },
]
